import React, { useContext, useState, useEffect } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import LanguageContext, {
  getCountryInfoByLocale,
  isValidLanguage,
} from '../../contexts/LanguageContext';
import { useConfigContext } from '../../contexts/ConfigContext';
import {
  FlagButton,
  FlagButtonImg,
  LocationLabel
} from './styles';
import LanguageMenu from './components/LanguageMenu';
import keycodes from '../../includes/keycodes';

const _isMobile = () => window.innerWidth < 577;

export default withRouter(({ isFooter, location }) => {
  const { REGIONS } = useConfigContext();
  const { language, setLanguage } = useContext(LanguageContext);

  const [isMobile, setIsMobile] = useState(false);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [menuByKeyboard, setMenuByKeyboard] = useState({ opened: false, closed: false });

  const { lang } = queryString.parse(location.search);
  let flagButton;

  // gets regions information and sets current country and language
  let country, regionIndex;
  if (REGIONS && REGIONS.length > 0) {
    const countryInfo = getCountryInfoByLocale(REGIONS, language.locale);

    country = countryInfo.country;
    regionIndex = countryInfo.regionIndex;
  }

  const loadLanguageURL = () => {
    if (lang !== undefined && isValidLanguage(REGIONS, lang)) {
      setLanguage({
        locale: lang,
      });
    } else {
      setLanguage(prev => {
        return {
          locale: prev.locale,
        };
      });
    }
  };

  useEffect(loadLanguageURL, [lang]);

  useEffect(() => {
    setIsMobile(_isMobile());

    const resizeCallback = () => {
      setIsMobile(_isMobile());
    };

    window.addEventListener('resize', resizeCallback);

    return () => window.removeEventListener('resize', resizeCallback);
  }, [setIsMobile]);

  // useEffect used to know if user opened the language menu using keyboard keys Enter or Space
  // if Space, then override default scrolling behavior and click to open menu
  useEffect(() => {
    const handleKeydown = event => {
      if (
        (event.keyCode === keycodes.ENTER || event.keyCode === keycodes.SPACE) &&
        event.target.dataset.id === 'flag-link'
      ) {
        setMenuByKeyboard({ opened: true, closed: false });
      }
    };

    window.addEventListener('keydown', handleKeydown);

    return () => window.removeEventListener('keydown', handleKeydown);
  }, [setMenuByKeyboard]);

  useEffect(() => {
    const btn = flagButton;

    setTimeout(() => {
      if (menuByKeyboard.closed) {
        btn.focus();
      }
    }, 300);
  }, [menuByKeyboard, flagButton]);

  return (
    <>
      {country && (
        <>
          <FlagButton
            data-testid="flag-link"
            data-id="flag-link"
            onClick={() => setLanguageMenuOpen(true)}
            className={`${country.languages.length > 1 ? 'separator' : ' '}${
              !isFooter && isMobile ? ' d-none' : ' '
            }`}
            isfooter={isFooter ? 'true' : undefined}
            ref={flag => {
              flagButton = flag;
            }}
          >
            {country?.image && <FlagButtonImg src={`/flags/${country.image}`} />}
            <LocationLabel isfooter={isFooter ? 'true' : undefined}>
              <span>
              { language?.locale?.replace('-', '/')?.toUpperCase() || "" }
              </span>
            </LocationLabel>
          </FlagButton>
          {languageMenuOpen && (
            <LanguageMenu
              handleLanguageMenuVisibility={setLanguageMenuOpen}
              languageMenuOpen={languageMenuOpen}
              initialRegionIndex={regionIndex}
              currentCountry={country.shortName}
              handleMenuByKeyboard={setMenuByKeyboard}
              menuByKeyboard={menuByKeyboard}
            />
          )}
        </>
      )}
    </>
  );
});
